import moment from 'moment'
import formatLead from '@/helpers/translateLead'

const leadTableHeaders = [
  { text: 'Thời gian đăng ký', value: 'create', show: true, width: '50' },
  { text: 'Họ tên học sinh', value: 'studentName', show: true, width: '150' },
  { text: 'Ngày sinh', value: 'studentDob', show: true, width: '120' },
  { text: 'Trường đang học', value: 'studentSchool', show: false, width: '150' },
  //
  { text: 'Hình thức học', value: 'studentLearningMethods', show: true, width: '120' },
  { text: 'Khoá học muốn tham gia', value: 'studentProducts', show: true, width: '120' },
  { text: 'Cơ sở đăng ký học', value: 'studentDepartments', show: true, width: '120' },
  //
  { text: 'SĐT PHHS', value: 'phone', show: true, width: '50' },
  { text: 'Thời gian lịch hẹn', value: 'appointmentDate', show: true, width: '100' },
  { text: 'Thời gian test', value: 'testDate', show: true, width: '80' },
  //
  { text: 'Người phụ trách', value: 'inCharge', show: true, width: 120 },
  { text: 'Nội dung tư vấn', value: 'consultNote', show: true, width: '120' },
  //
  { text: 'Họ tên PHHS', value: 'buyerName', show: false, width: '150' },
  { text: 'Nguồn marketing', value: 'importOrigin', show: false, width: '100' },
  //
  { text: 'Hệ đào tạo', value: 'products', show: false, width: '120' },
  { text: 'Độ quan tâm', value: 'interest', show: false, width: '80' },
  { text: 'Phân khúc', value: 'segment', show: false, width: '100' },
  { text: 'Ghi chú', value: 'note', show: false, width: '200' },
  { text: 'G.Đ chăm sóc', value: 'status', show: false, width: '130' },
  //
  { text: 'Thao tác', value: 'actions', show: true, width: '130', default: true, align: 'center' },
]

const CONFIG_KEYS = {
  STUDENT_LEARNING_METHOD: 'studentLearningMethod',
  STUDENT_PRODUCT: 'studentProduct',
  STUDENT_DEPARTMENT: 'studentDeparment',
}

const LEAD_CARE_STEPS = [
  { s: 1, t: 'Chưa chăm sóc' },
  { s: 2, t: 'Đã đặt lịch hẹn' },
  { s: 3, t: 'Đã tư vấn trực tiếp' },
  { s: 4, t: '' },
]

const displayDataInConfigs = ({ configs = [], type = '', separator = '<br/>', valuePrefix = '- ', data = [] }) => {
  const config = configs.find(c => c.key === type)
  if (!config) return ''
  return config.value
    .filter(v => data.includes(v.key))
    .map(v => `${valuePrefix}${v.value}`)
    .join(separator)
}

const IMPORT_SAMPLE_FIELDS = {
  'SĐT PHHS': 'phone',
  'Họ tên PHHS': 'buyerName',
  'Email PHHS': 'email',
  'Họ và tên HS': 'studentName',
  'Ngày tháng năm sinh': 'studentDob',
  'Trường đang theo học': 'studentSchool',
  'Trường dự định thi': 'expectSchool',
  'Hình thức theo học': 'studentLearningMethods',
  'Khóa học muốn tham gia': 'studentProducts',
  'Cơ sở đăng ký': 'studentDepartments',
}
const IMPORT_SAMPLE_DATA = [
  {
    phone: '0948250571',
    buyerName: 'Nguyễn Văn Bố',
    email: 'email@example.com',
    studentName: 'Nguyễn Văn Con',
    studentDob: '22/03/2007',
    studentSchool: 'Tên trường Con đang học hoặc bỏ trống',
    studentLearningMethods: 'Trực tuyến (Online) // Trực tiếp (Offline)',
    studentProducts:
      'Tiếng Anh toàn diện (Cấp 1, 2, 3) // Luyện thi chuyển cấp 5 lên 6 // Luyện thi 9 lên 10 điều kiện // Luyện thi 9 lên 10 chuyên Anh // Tiếng Anh tài năng // Luyện thi HSG của Bộ, Sở GD & các kì thi TA khác (OE - IOE, TOEFL Challenge,...) // Luyện thi Đại Học // Chứng chỉ IELTS',
    expectSchool: 'Trường Con dự định thi vào hoặc bỏ trống',
    studentDepartments:
      'ĐỐNG ĐA: 173 ngõ Xã Đàn 2 // CẦU GIẤY: Số 22 ngách 6 ngõ 118 Nguyễn Khánh Toàn // HÀ ĐÔNG: Lô F34 Đồng Dưa // ONLINE',
  },
]
const IMPORT_SCHEMA = {
  'SĐT PHHS': { prop: 'phone', type: String },
  SĐT: { prop: 'phoneAlias', type: String },
  'Họ tên PHHS': { prop: 'buyerName', type: String },
  'Email PHHS': { prop: 'email', type: String },
  'Họ và tên HS': { prop: 'studentName', type: String },
  'Ngày tháng năm sinh': { prop: 'studentDob', type: String },
  'Trường đang theo học': { prop: 'studentSchool', type: String },
  'Trường dự định thi': { prop: 'expectSchool', type: String },
  'Hình thức theo học': { prop: 'studentLearningMethods', type: String },
  'Khóa học muốn tham gia': { prop: 'studentProducts', type: String },
  'Cơ sở đăng ký': { prop: 'studentDepartments', type: String },
}
const IMPORT_PREVIEW_TABLE_HEADER = [
  { text: 'SĐT PHHS', value: 'phone' },
  { text: 'Họ tên PHHS', value: 'buyerName' },
  { text: 'Email PHHS', value: 'email' },
  { text: 'Họ và tên HS', value: 'studentName' },
  { text: 'Ngày tháng năm sinh', value: 'studentDob' },
  { text: 'Trường đang theo học', value: 'studentSchool' },
  { text: 'Trường dự định thi', value: 'expectSchool' },
  { text: 'Hình thức theo học', value: 'studentLearningMethods' },
  { text: 'Khóa học muốn tham gia', value: 'studentProducts' },
  { text: 'Cơ sở đăng ký', value: 'studentDepartments' },
]

const EXPORT_FIELDS = {
  'Thời gian đăng ký': {
    field: 'createdAt',
    callback: val => (val ? moment(val).format('DD/MM/YYYY HH:mm') : ''),
  },
  'Họ và tên HS': 'studentName',
  'Ngày tháng năm sinh': 'studentDob',
  'Hình thức theo học': 'studentLearningMethods',
  'Khóa học muốn tham gia': 'studentProducts',
  'Cơ sở đăng ký': 'studentDepartments',
  SĐT: 'phone',
  'Ngày + Giờ test': {
    field: 'testDate',
    callback: val => (val ? moment(val).format('DD/MM/YYYY HH:mm') : ''),
  },
  'Nhân viên tư vấn': 'inCharge.name',
  'Nội dung tư vấn': 'consultNote',
  //
  'Trường dự định thi': 'expectSchool',
  'Họ tên PHHS': 'buyerName',
  'Email PHHS': 'email',
  'Trường đang theo học': 'studentSchool',
  'Nguồn marketing': {
    field: 'importedOrigin',
    callback: val => formatLead(val),
  },
  'Sản phẩm quan tâm': 'product',
  'Ghi chú': 'note',
  'G.Đ chăm sóc': {
    field: 'status',
    callback: value => formatLead(value),
  },
  'Người tạo': 'createdByName',
}

const LEAD_IMPORT_ORIGIN_OPTIONS = [
  { text: 'Trực tiếp', value: 'native' },
  { text: 'Google Form', value: 'googleForm' },
  { text: 'Mạng xã hội', value: 'socialNetwork' },
]

export {
  leadTableHeaders,
  CONFIG_KEYS,
  LEAD_CARE_STEPS,
  displayDataInConfigs,
  IMPORT_SAMPLE_DATA,
  IMPORT_SAMPLE_FIELDS,
  IMPORT_SCHEMA,
  IMPORT_PREVIEW_TABLE_HEADER,
  EXPORT_FIELDS,
  LEAD_IMPORT_ORIGIN_OPTIONS,
}
